import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { tenantAPI } from '../../api/client';

const fmt = (n, unit) => (unit === 'GB' ? `${Number(n).toFixed(n < 1 ? 2 : 1)} GB` : Number(n).toLocaleString('en-IN'));

/**
 * "Usage this month": the company's usage against its plan's limits (Usage & Limits Control), with a warning from each
 * limit's threshold. Reaching a limit that blocks (users, numbers, call minutes, call flows) stops that action.
 */
export default function UsageCard() {
  const [rows, setRows] = useState(null);
  useEffect(() => { tenantAPI.usage().then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows?.length) return null;
  const alerts = rows.filter((r) => r.state === 'warning' || r.state === 'over');
  return (
    <section className="panel page-info-card usage-card">
      <div className="panel-heading"><h2>Usage this month</h2></div>
      {alerts.length > 0 && (
        <div className="usage-alert" role="status"><AlertTriangle size={15} />
          {alerts.map((r) => `${r.name}: ${r.state === 'over' ? 'limit reached' : `${r.percent}% used`}`).join(' · ')}
          {alerts.some((r) => r.state === 'over' && r.blocks) && '. Upgrade your plan or ask TeleCalX for more.'}
        </div>
      )}
      <div className="usage-rows">
        {rows.map((r) => (
          <div className={`usage-row ${r.state}`} key={r.resource}>
            <div className="usage-row-text"><span>{r.name}</span>
              <b>{fmt(r.used, r.unit)}{r.state === 'unlimited' ? ' · no limit' : ` / ${fmt(r.limit, r.unit)}`}</b></div>
            <div className="usage-track"><i style={{ width: `${r.state === 'unlimited' ? 0 : Math.min(100, r.percent ?? 0)}%` }} /></div>
          </div>
        ))}
      </div>
    </section>
  );
}
